<template>
  <div>
    <v-dialog
      v-model="visible"
      style="z-index: 1000"
      persistent
      max-width="780px"
      width="48vw"
    >
      <v-card>
        <v-card-title v-if="message" class="headline body" primary-title>{{
          message
        }}</v-card-title>
        <v-card-text v-if="body && body.length" v-html="body" class="body" />
        <img v-if="imageUrl" :src="imageUrl" />
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <AppButtonCancel v-if="!onlyOk" @click="cancel">
            {{ cancelText }}
          </AppButtonCancel>
          <AppButtonOk
            @click="ok"
            :color="okButtonColor"
            :class="okButtonClass"
          >
            {{ okText }}
          </AppButtonOk>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <GlobalEvents @keydown.esc="cancel" @keydown.enter.shift="ok" />
  </div>
</template>

<script>
import GlobalEvents from 'vue-global-events'

export default {
  name: 'ConfirmModal',
  components: { GlobalEvents },
  props: {
    message: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    onlyOk: {
      type: Boolean,
      default: false,
    },
    onSuccess: {
      type: Function,
      default: () => {},
    },
    onFailure: {
      type: Function,
      default: () => {},
    },
    okText: {
      type: String,
      default: 'はい',
    },
    okButtonColor: {
      type: String,
      default: 'primary',
    },
    okButtonClass: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: 'いいえ',
    },
    imageUrl: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  created() {
    const el = document.createElement('div')
    document.getElementsByTagName('body')[0].appendChild(el)
    this.$mount(el)

    this.visible = true
  },
  methods: {
    ok() {
      this.onSuccess()
      this.destroy()
    },
    cancel() {
      this.onFailure()
      this.destroy()
    },
    destroy() {
      this.visible = false
      setTimeout(() => {
        this.$el.parentNode.removeChild(this.$el)
        this.$destroy()
      }, 200)
    },
  },
}
</script>

<style scoped>
.body {
  white-space: pre-line;
  word-wrap: break-word;
}
</style>
